import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CreateArtifactContext } from "../../../context/CreateArtifactContext";
import { Tier } from "../../../models/SKArtifact";
import { useNavigationBar } from "../../../context/NavigationContext";
import { createArtifact } from "../../../api/artifacts/atrifactService";

function Publish() {
  const { contentData, updateContentData } = useContext(CreateArtifactContext);

  let element = <img src={"/icons/checkFilled.png"} className="w-[18px] h-[18px] rounded-lg" alt="publish" />;

  const navigate = useNavigate();

  const { setNavProps } = useNavigationBar();
  // import { useNavigationBar } from "../../../context/NavigationContext";
  useEffect(() => {
    const submit = async () => {
      // call submit API
      //await createArtifact(contentData);
      navigate("successSubmit");
    };

    setNavProps({
      backArrow: false,
      title: "Content",
      subtitle: "Channel",
      buttonTitle: "Submit",
      filterOption: false,
      enableLink: true,
      onBack: () => alert("Back Clicked"),
      onFilter: () => {},
      onNext: () => window.history.back(),
      onClose: () => {
        navigate(-1);
      },
    });
  }, [setNavProps, navigate, contentData]);

  // useEffect(() => {
  //   console.log(contentData.topic);
  // }, [contentData]);

  return (
    <>
      {/* <div className="flex flex-row h-[50px] my-3 w-full justify-between">
        <div className="flex flex-row items-center content-center float-left text-lg font-bold">
          <button
            onClick={() => window.history.back()} // Use history object to navigate back
            className="flex items-center px-3 py-2" // Ensuring the button content is also centered
          >
            <img src={`/icons/back.png`} alt="Back" className="w-6 h-6" />
          </button>
          <span className="text-lg">Content</span>
        </div>
        <div className="float-right">
          <Link
            to="../successSubmit"
            className="flex items-center justify-center px-3 py-2 text-sm font-normal text-center text-white bg-black rounded-lg"
          >
            <button className="w-full h-full">Submit</button>
          </Link>
        </div>
      </div>
      <div className="thickseparator"></div> */}
      <div className="flex flex-col p-2">
        <span className="text-lg font-bold">Choose publishing tier</span>
        {Object.values(Tier).map((data, index) => (
          <div
            onClick={() => updateContentData({ ...contentData, tier: data })}
            key={index}
            className=" border-skseparatorgray border-b-[1px] flex flex-row first-letter w-full items-center gap-3 p-4 mb-4 "
          >
            <div className="flex items-center justify-center flex-shrink-0 w-5 h-5 border-[1px] rounded-full border-gray">
              {contentData.tier === data ? element : <></>}
            </div>

            <span className="mt-1 text-sm">{data.toUpperCase()}</span>
          </div>
        ))}
      </div>
      <div className="flex flex-col p-2">
        <span className="text-lg font-bold">Choose publishing sequence</span>
        <div
          onClick={() => updateContentData({ ...contentData, autoPublish: true })}
          key={1}
          className=" border-skseparatorgray border-b-[1px] flex flex-row first-letter w-full items-center gap-3 p-4 mb-4 "
        >
          <div className="flex items-center justify-center flex-shrink-0 w-5 h-5 border-[1px] rounded-full border-gray">
            {contentData.autoPublish === true ? element : <></>}
          </div>

          <span className="mt-1 text-sm">Auto publish after approval</span>
        </div>
        <div
          onClick={() => updateContentData({ ...contentData, autoPublish: false })}
          key={2}
          className=" border-skseparatorgray border-b-[1px] flex flex-row first-letter w-full items-center gap-3 p-4 mb-4 "
        >
          <div className="flex items-center justify-center flex-shrink-0 w-5 h-5 border-[1px] rounded-full border-gray">
            {contentData.autoPublish === false ? element : <></>}
          </div>

          <span className="mt-1 text-sm">Do not auto publish after approval. I will manually publish.</span>
        </div>
      </div>
    </>
  );
}

export default Publish;
